var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('img',{staticClass:"h-7 w-28 lg:h-8 lg:w-32",attrs:{"src":require("@/assets/images/logo.png"),"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }